// extracted by mini-css-extract-plugin
export default {"root":"_2WlEn","variant-subscriptions":"_5Bssx","variantSubscriptions":"_5Bssx","variant-adoptables":"_2kf8i","variantAdoptables":"_2kf8i"};